import styled, { keyframes } from "styled-components";

const generateAnimation = (frameCount, productivity) => {
  let animation = "";
  for (let i = 0; i <= frameCount; i++) {
    const start = (i * 100) / frameCount;
    const grow = (i * productivity) / frameCount;
    animation += `
    ${start}% {
      background: conic-gradient(
        from 90deg,
        hsla(${0 + grow * 1.2},100%,40%,1) 0% ${grow}%,
        rgba(255,255,255,1) ${grow + 10}% 100%
      );
    }
    `;
  }
  return keyframes`${animation}`;
};

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Circle = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  animation: ${(props) =>
      generateAnimation(props.frameCount, props.productivity)}
    2s forwards;
`;

export const InnerGround = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
`;

export const Display = styled.span`
  font-weight: 700;
  font-size: 0.8rem;
  ${({ productivity }) => `
    color: hsla(${productivity * 1.2}, 100%, 40%, 1);
  `}
`;
